import React from "react";
import Button from "antd/lib/button";
const ButtonGroup = Button.Group;

const Social = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ButtonGroup
        style={{
          marginRight: "33px"
        }}
      >
        <Button icon="share-alt" disabled style={{ color: "black" }}>
          SHARE
        </Button>
        <Button
          href="mailto:?subject=Blockchain Demo: Visual demo of blockchain technology&amp;body=Check out this site! https://blockchaindemo.io"
          type="primary"
          icon="mail"
          target="_blank"
        />
        <Button 
          type="primary"
          href="https://plus.google.com/share?url=https://blockchaindemo.io"
          icon="google-plus"
          target="_blank"
        />
        <Button
          href="https://www.facebook.com/sharer/sharer.php?u=#url"
          type="primary"
          icon="facebook"
          target="_blank"
        />
        <Button
          href="https://www.linkedin.com/shareArticle?mini=true&url=https://blockchaindemo.io&title=Coin%20Demo&summary=Visual%20demo%20of%20blockchain%20technologies&source=SeanJamesHan"
          type="primary" 
          icon="linkedin"
          target="_blank"
        />
        <Button
          href="https://twitter.com/share?url=https%3A%2F%2Fblockchaindemo.io&via=seanjameshan&related=ProductHunt%2CfreeCodeCamp&hashtags=Blockchain%2CBlockchain%2CEducation%2CDemo%2CLearn&text=Blockchain%20Demo%20-%20Visual%20demonstration%20of%20blockchain%20technologies"
          type="primary"
          icon="twitter"
          target="_blank"
        />
      </ButtonGroup>
      <ButtonGroup>
        <Button
          type="primary"
          icon="twitter"
          href="https://twitter.com/seanjameshan"
          target="_blank"
        />
        <Button
          type="primary"
          icon="linkedin"
          href="https://www.linkedin.com/in/seanjameshan/"
          target="_blank"
        />
        <Button
          type="primary"
          icon="medium"
          href="https://medium.com/@seanjameshan"
          target="_blank"
        />
        <Button
          type="primary"
          icon="github"
          href="https://github.com/seanjameshan"
          target="_blank"
        />
        <Button
          type="primary"
          icon="mail"
          href="mailto:sean.han@mail.utoronto.ca"
          target="_blank"
        />
        <Button icon="heart-o" disabled style={{ color: "black" }}>
          CONNECT
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Social;



// WEBPACK FOOTER //
// ./src/Social.js